// @ts-nocheck
import { Option } from '@branchjs/neo-components';
import { endOfDay, format, subDays } from 'date-fns';

import server from '../../support/server';
import dash_api from '../../support/dash_api';
import NotificationActions from '../NotificationActions';
import { ReduxAsyncAction } from '../../support/utils';
import { ActionNamespaceConstants } from '../../types/reduxAsyncAction';
import { Kind } from '../../screens/ScreenLinkHubAdLinkCreator/steps/GeneralStep/General.types';
import { Redirect } from '../../screens/ScreenLinkHubAdLinkCreator/steps/RedirectsStep/Redirects.types';
import { linkMacrosAreEqual } from '../../screens/LinkCreator/utils';
import { OsPlatform } from '../../screens/ScreenLinkHubAdLinkCreator/steps/GeneralStep/types/OsPlatformType';
import { AdLinkCreatorReducerType } from '../../reducers/AdLinkCreatorReducer/types/AdLinkCreatorReducerType';
import { AdLinkCreatorService } from '../../services/AdLinkCreatorService/AdLinkCreatorService';
import { AdLinkEditorService } from '../../services/AdLinkEditorService/AdLinkEditorService';
import { IAdLinkTemplate } from '../../types/adLinkTypes';
import { ILinkTemplateRecord } from '../../../../../shared/types';
import { AdPartner } from '../../types/adPartnerTypes';

const CLEAR_AD_LINK_NAMESPACE = 'CLEAR_AD_LINK' as const;
const ClearAdLink = new ReduxAsyncAction(CLEAR_AD_LINK_NAMESPACE);
ClearAdLink.registerRequest(async () => {
  return {};
});

const CLEAR_CREATED_AD_LINK_NAMESPACE = 'CLEAR_CREATED_AD_LINK' as const;
const ClearCreatedAdLink = new ReduxAsyncAction(CLEAR_CREATED_AD_LINK_NAMESPACE);
ClearCreatedAdLink.registerRequest(async () => {
  return {
    createAdLink: undefined,
  };
});

export const CLEAR_CREATED_AD_LINK: ActionNamespaceConstants<typeof CLEAR_CREATED_AD_LINK_NAMESPACE> =
  ClearCreatedAdLink.constants;
export const clearCreatedAdLink = ClearCreatedAdLink.request;

const CLEAR_SELECTED_AD_LINK_NAMESPACE = 'CLEAR_SELECTED_AD_LINK' as const;
const ClearSelectedAdLink = new ReduxAsyncAction(CLEAR_SELECTED_AD_LINK_NAMESPACE);
ClearSelectedAdLink.registerRequest(async () => {
  return {
    selectedAdLink: undefined,
  };
});

export const CLEAR_SELECTED_AD_LINK: ActionNamespaceConstants<typeof CLEAR_SELECTED_AD_LINK_NAMESPACE> =
  ClearSelectedAdLink.constants;
export const clearSelectedAdLink = ClearSelectedAdLink.request;

const UPDATE_STEP_NAMESPACE = 'UPDATE_STEP' as const;
const UpdateStep = new ReduxAsyncAction(UPDATE_STEP_NAMESPACE);
UpdateStep.registerRequest(async (step: string) => {
  return { step };
});

export const UPDATE_STEP: ActionNamespaceConstants<typeof UPDATE_STEP_NAMESPACE> = UpdateStep.constants;
export const updateStep = UpdateStep.request;

const UPDATE_IS_GENERAL_STEP_VISITED_NAMESPACE = 'UPDATE_IS_GENERAL_STEP_VISITED' as const;
const UpdateIsGeneralStepVisited = new ReduxAsyncAction(UPDATE_IS_GENERAL_STEP_VISITED_NAMESPACE);
UpdateIsGeneralStepVisited.registerRequest(async (isGeneralStepVisited: boolean) => {
  return { isGeneralStepVisited };
});

export const UPDATE_IS_GENERAL_STEP_VISITED: ActionNamespaceConstants<typeof UPDATE_IS_GENERAL_STEP_VISITED_NAMESPACE> =
  UpdateIsGeneralStepVisited.constants;
export const updateIsGeneralStepVisited = UpdateIsGeneralStepVisited.request;

const UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED_NAMESPACE = 'UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED' as const;
const UpdateIsAnalyticsTagsStepVisited = new ReduxAsyncAction(UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED_NAMESPACE);
UpdateIsAnalyticsTagsStepVisited.registerRequest(async (isAnalyticsTagsStepVisited: boolean) => {
  return { isAnalyticsTagsStepVisited };
});

export const UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED: ActionNamespaceConstants<
  typeof UPDATE_IS_ANALYTICS_TAGS_STEP_VISITED_NAMESPACE
> = UpdateIsAnalyticsTagsStepVisited.constants;
export const updateIsAnalyticsTagsStepVisited = UpdateIsAnalyticsTagsStepVisited.request;

const UPDATE_IS_REDIRECTS_STEP_VISITED_NAMESPACE = 'UPDATE_IS_REDIRECTS_STEP_VISITED' as const;
const UpdateIsRedirectsStepVisited = new ReduxAsyncAction(UPDATE_IS_REDIRECTS_STEP_VISITED_NAMESPACE);
UpdateIsRedirectsStepVisited.registerRequest(async (isRedirectsStepVisited: boolean) => {
  return { isRedirectsStepVisited };
});

export const UPDATE_IS_REDIRECTS_STEP_VISITED: ActionNamespaceConstants<typeof UPDATE_IS_REDIRECTS_STEP_VISITED_NAMESPACE> =
  UpdateIsRedirectsStepVisited.constants;
export const updateIsRedirectsStepVisited = UpdateIsRedirectsStepVisited.request;

const UPDATE_IS_LINK_DATA_STEP_VISITED_NAMESPACE = 'UPDATE_IS_LINK_DATA_STEP_VISITED' as const;
const UpdateIsLinkDataStepVisited = new ReduxAsyncAction(UPDATE_IS_LINK_DATA_STEP_VISITED_NAMESPACE);
UpdateIsLinkDataStepVisited.registerRequest(async (isLinkDataStepVisited: boolean) => {
  return { isLinkDataStepVisited };
});

export const UPDATE_IS_LINK_DATA_STEP_VISITED: ActionNamespaceConstants<typeof UPDATE_IS_LINK_DATA_STEP_VISITED_NAMESPACE> =
  UpdateIsLinkDataStepVisited.constants;
export const updateIsLinkDataStepVisited = UpdateIsLinkDataStepVisited.request;

const UPDATE_IS_BLACKLIST_ERROR_NAMESPACE = 'UPDATE_IS_BLACKLIST_ERROR' as const;
const UpdateIsBlacklistError = new ReduxAsyncAction(UPDATE_IS_BLACKLIST_ERROR_NAMESPACE);
UpdateIsBlacklistError.registerRequest(async (isBlacklistError: boolean) => {
  return { isBlacklistError };
});

export const UPDATE_IS_BLACKLIST_ERROR: ActionNamespaceConstants<typeof UPDATE_IS_BLACKLIST_ERROR_NAMESPACE> =
  UpdateIsBlacklistError.constants;
export const updateIsBlacklistError = UpdateIsBlacklistError.request;

export const CLEAR_AD_LINK: ActionNamespaceConstants<typeof CLEAR_AD_LINK_NAMESPACE> = ClearAdLink.constants;
export const clearAdLink = ClearAdLink.request;

const UPDATE_KIND_NAMESPACE = 'UPDATE_KIND' as const;
const UpdateKind = new ReduxAsyncAction(UPDATE_KIND_NAMESPACE);
UpdateKind.registerRequest(async (kind: Kind) => {
  return { kind };
});

export const UPDATE_KIND: ActionNamespaceConstants<typeof UPDATE_KIND_NAMESPACE> = UpdateKind.constants;
export const updateKind = UpdateKind.request;

const UPDATE_ALIAS_NAMESPACE = 'UPDATE_ALIAS' as const;
const UpdateAlias = new ReduxAsyncAction(UPDATE_ALIAS_NAMESPACE);
UpdateAlias.registerRequest(async (alias: string) => {
  return { alias };
});

export const UPDATE_ALIAS: ActionNamespaceConstants<typeof UPDATE_ALIAS_NAMESPACE> = UpdateAlias.constants;
export const updateAlias = UpdateAlias.request;

const UPDATE_TITLE_NAMESPACE = 'UPDATE_TITLE' as const;
const UpdateTitle = new ReduxAsyncAction(UPDATE_TITLE_NAMESPACE);
UpdateTitle.registerRequest(async (title: string) => {
  return { title };
});

export const UPDATE_TITLE: ActionNamespaceConstants<typeof UPDATE_TITLE_NAMESPACE> = UpdateTitle.constants;
export const updateTitle = UpdateTitle.request;

const UPDATE_PARTNER_NAMESPACE = 'UPDATE_PARTNER' as const;
const UpdatePartner = new ReduxAsyncAction(UPDATE_PARTNER_NAMESPACE);
UpdatePartner.registerRequest(async (partner: Option) => {
  return { partner };
});

export const UPDATE_PARTNER: ActionNamespaceConstants<typeof UPDATE_PARTNER_NAMESPACE> = UpdatePartner.constants;
export const updatePartner = UpdatePartner.request;

const UPDATE_ORIGINAL_WEB_URL_NAMESPACE = 'UPDATE_ORIGINAL_WEB_URL' as const;
const UpdateOriginalWebUrl = new ReduxAsyncAction(UPDATE_ORIGINAL_WEB_URL_NAMESPACE);
UpdateOriginalWebUrl.registerRequest(async (originalWebUrl: string) => {
  return { originalWebUrl };
});

export const UPDATE_ORIGINAL_WEB_URL: ActionNamespaceConstants<typeof UPDATE_ORIGINAL_WEB_URL_NAMESPACE> =
  UpdateOriginalWebUrl.constants;
export const updateOriginalWebUrl = UpdateOriginalWebUrl.request;

const UPDATE_OS_PLATFORM_NAMESPACE = 'UPDATE_OS_PLATFORM' as const;
const UpdateOsPlatform = new ReduxAsyncAction(UPDATE_OS_PLATFORM_NAMESPACE);
UpdateOsPlatform.registerRequest(async (osPlatform: OsPlatform) => {
  return { osPlatform };
});

export const UPDATE_OS_PLATFORM: ActionNamespaceConstants<typeof UPDATE_OS_PLATFORM_NAMESPACE> = UpdateOsPlatform.constants;
export const updateOsPlatform = UpdateOsPlatform.request;

const UPDATE_CHANNEL_NAMESPACE = 'UPDATE_CHANNEL' as const;
const UpdateChannel = new ReduxAsyncAction(UPDATE_CHANNEL_NAMESPACE);
UpdateChannel.registerRequest(async (channel: Option) => {
  return { channel };
});

export const UPDATE_CHANNEL: ActionNamespaceConstants<typeof UPDATE_CHANNEL_NAMESPACE> = UpdateChannel.constants;
export const updateChannel = UpdateChannel.request;

const UPDATE_CAMPAIGN_NAMESPACE = 'UPDATE_CAMPAIGN' as const;
const UpdateCampaign = new ReduxAsyncAction(UPDATE_CAMPAIGN_NAMESPACE);
UpdateCampaign.registerRequest(async (campaign: Option) => {
  return { campaign };
});

export const UPDATE_CAMPAIGN: ActionNamespaceConstants<typeof UPDATE_CAMPAIGN_NAMESPACE> = UpdateCampaign.constants;
export const updateCampaign = UpdateCampaign.request;

const UPDATE_TAGS_NAMESPACE = 'UPDATE_TAGS' as const;
const UpdateTags = new ReduxAsyncAction(UPDATE_TAGS_NAMESPACE);
UpdateTags.registerRequest(async (tags: Option | Option[]) => {
  return { tags };
});

export const UPDATE_TAGS: ActionNamespaceConstants<typeof UPDATE_TAGS_NAMESPACE> = UpdateTags.constants;
export const updateTags = UpdateTags.request;

const UPDATE_IOS_REDIRECT_NAMESPACE = 'UPDATE_IOS_REDIRECT' as const;
const UpdateIosRedirect = new ReduxAsyncAction(UPDATE_IOS_REDIRECT_NAMESPACE);
UpdateIosRedirect.registerRequest(async (iosRedirect: Redirect) => {
  return { iosRedirect };
});

export const UPDATE_IOS_REDIRECT: ActionNamespaceConstants<typeof UPDATE_IOS_REDIRECT_NAMESPACE> =
  UpdateIosRedirect.constants;
export const updateIosRedirect = UpdateIosRedirect.request;

const UPDATE_ANDROID_REDIRECT_NAMESPACE = 'UPDATE_ANDROID_REDIRECT' as const;
const UpdateAndroidRedirect = new ReduxAsyncAction(UPDATE_ANDROID_REDIRECT_NAMESPACE);
UpdateAndroidRedirect.registerRequest(async (androidRedirect: Redirect) => {
  return { androidRedirect };
});

export const UPDATE_ANDROID_REDIRECT: ActionNamespaceConstants<typeof UPDATE_ANDROID_REDIRECT_NAMESPACE> =
  UpdateAndroidRedirect.constants;
export const updateAndroidRedirect = UpdateAndroidRedirect.request;

const UPDATE_DESKTOP_REDIRECT_NAMESPACE = 'UPDATE_DESKTOP_REDIRECT' as const;
const UpdateDesktopRedirect = new ReduxAsyncAction(UPDATE_DESKTOP_REDIRECT_NAMESPACE);
UpdateDesktopRedirect.registerRequest(async (desktopRedirect: Redirect) => {
  return { desktopRedirect };
});

export const UPDATE_DESKTOP_REDIRECT: ActionNamespaceConstants<typeof UPDATE_DESKTOP_REDIRECT_NAMESPACE> =
  UpdateDesktopRedirect.constants;
export const updateDesktopRedirect = UpdateDesktopRedirect.request;

const UPDATE_IOS_NAMESPACE = 'UPDATE_IOS' as const;
const UpdateIos = new ReduxAsyncAction(UPDATE_IOS_NAMESPACE);
UpdateIos.registerRequest(async (ios: string | Option) => {
  return { ios };
});

export const UPDATE_IOS: ActionNamespaceConstants<typeof UPDATE_IOS_NAMESPACE> = UpdateIos.constants;
export const updateIos = UpdateIos.request;

const UPDATE_ANDROID_NAMESPACE = 'UPDATE_ANDROID' as const;
const UpdateAndroid = new ReduxAsyncAction(UPDATE_ANDROID_NAMESPACE);
UpdateAndroid.registerRequest(async (android: string | Option) => {
  return { android };
});

export const UPDATE_ANDROID: ActionNamespaceConstants<typeof UPDATE_ANDROID_NAMESPACE> = UpdateAndroid.constants;
export const updateAndroid = UpdateAndroid.request;

const UPDATE_DESKTOP_NAMESPACE = 'UPDATE_DESKTOP' as const;
const UpdateDesktop = new ReduxAsyncAction(UPDATE_DESKTOP_NAMESPACE);
UpdateDesktop.registerRequest(async (desktop: string | Option) => {
  return { desktop };
});

export const UPDATE_DESKTOP: ActionNamespaceConstants<typeof UPDATE_DESKTOP_NAMESPACE> = UpdateDesktop.constants;
export const updateDesktop = UpdateDesktop.request;

const UPDATE_LINK_DATA_NAMESPACE = 'UPDATE_LINK_DATA' as const;
const UpdateLinkData = new ReduxAsyncAction(UPDATE_LINK_DATA_NAMESPACE);
UpdateLinkData.registerRequest(async (linkData: Record<string, any>) => {
  return { linkData };
});

export const UPDATE_LINK_DATA: ActionNamespaceConstants<typeof UPDATE_LINK_DATA_NAMESPACE> = UpdateLinkData.constants;
export const updateLinkData = UpdateLinkData.request;

const FETCH_AVAILABLE_AD_PARTNERS_NAMESPACE = 'FETCH_AVAILABLE_AD_PARTNERS' as const;
const FetchAvailableAdPartners = new ReduxAsyncAction(FETCH_AVAILABLE_AD_PARTNERS_NAMESPACE);
FetchAvailableAdPartners.registerRequest(async (): Option[] => {
  const appAdPartners: Record<string, AdPartner> = await dash_api.get(`/v1/ad-networks/app`).then(({ data }) => data);
  const globalAdPartners: AdPartner[] = await dash_api.get('/v1/ad-networks/global').then(({ data }) => data);

  const osTypeEnabledLookup: Record<string, boolean> = {};
  const availableAdPartners: AdPartner[] = [];

  globalAdPartners.forEach((globalAdPartner) => {
    if (Object.keys(appAdPartners).includes(globalAdPartner.machine_name)) {
      const adPartner = appAdPartners[globalAdPartner.machine_name];

      if (adPartner) {
        availableAdPartners.push({
          ...adPartner,
          company_name: globalAdPartner.company_name,
        });

        const linkOnlyParameters = globalAdPartner.link_only_parameters;
        if (!linkOnlyParameters) {
          osTypeEnabledLookup[globalAdPartner.machine_name] = false;
        } else if (
          !linkMacrosAreEqual(linkOnlyParameters, 'CLICK_AAID', 'CLICK_IDFA') &&
          !linkMacrosAreEqual(linkOnlyParameters, 'CLICK_AAID_SHA1', 'CLICK_IDFA_SHA1') &&
          !linkMacrosAreEqual(linkOnlyParameters, 'CLICK_AAID_MD5', 'CLICK_IDFA_MD5')
        ) {
          osTypeEnabledLookup[globalAdPartner.machine_name] = false;
        } else {
          osTypeEnabledLookup[globalAdPartner.machine_name] = true;
        }
      }
    }
  });

  for (const key in appAdPartners) {
    if (key.includes('a_custom')) {
      availableAdPartners.push(appAdPartners[key]);
      osTypeEnabledLookup[appAdPartners[key].machine_name] = false;
    }
  }

  return { availableAdPartners, osTypeEnabledLookup };
});

export const FETCH_AVAILABLE_AD_PARTNERS: ActionNamespaceConstants<typeof FETCH_AVAILABLE_AD_PARTNERS_NAMESPACE> =
  FetchAvailableAdPartners.constants;
export const fetchAvailableAdPartners = FetchAvailableAdPartners.request;

const FETCH_CHANNEL_OPTIONS_NAMESPACE = 'FETCH_CHANNEL_OPTIONS' as const;
const FetchChannelOptions = new ReduxAsyncAction(FETCH_CHANNEL_OPTIONS_NAMESPACE);
FetchChannelOptions.registerRequest(async () => {
  const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

  const startTimestamp = format(endOfDay(new Date()), DATE_FORMAT);
  const endTimestamp = format(
    subDays(new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate())), 90),
    DATE_FORMAT
  );

  try {
    const { data } = await dash_api.post('/v1/marketing/topchannel', {
      start_time: startTimestamp,
      end_time: endTimestamp,
    });

    return data;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch channel options.', 'error');
    throw error;
  }
});

export const FETCH_CHANNEL_OPTIONS: ActionNamespaceConstants<typeof FETCH_CHANNEL_OPTIONS_NAMESPACE> =
  FetchChannelOptions.constants;
export const fetchChannelOptions = FetchChannelOptions.request;

const FETCH_CAMPAIGN_OPTIONS_NAMESPACE = 'FETCH_CAMPAIGN_OPTIONS' as const;
const FetchCampaignOptions = new ReduxAsyncAction(FETCH_CAMPAIGN_OPTIONS_NAMESPACE);
FetchCampaignOptions.registerRequest(async () => {
  const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

  const startTimestamp = format(endOfDay(new Date()), DATE_FORMAT);
  const endTimestamp = format(
    subDays(new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate())), 90),
    DATE_FORMAT
  );

  try {
    const { data } = await dash_api.post('/v1/marketing/topcampaign', {
      start_time: startTimestamp,
      end_time: endTimestamp,
    });

    return data;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch campaign options.', 'error');
    throw error;
  }
});

export const FETCH_CAMPAIGN_OPTIONS: ActionNamespaceConstants<typeof FETCH_CAMPAIGN_OPTIONS_NAMESPACE> =
  FetchCampaignOptions.constants;
export const fetchCampaignOptions = FetchChannelOptions.request;

const SEARCH_IOS_APP_NAME_NAMESPACE = 'SEARCH_IOS_APP_NAME' as const;
const SearchIosAppName = new ReduxAsyncAction(SEARCH_IOS_APP_NAME_NAMESPACE);
SearchIosAppName.registerRequest(async (appId: string) => {
  const appIdWithoutIdPrefix = appId.slice(2);

  const response = await fetch(`https://itunes.apple.com/lookup?id=${appIdWithoutIdPrefix}&country=no`, {
    method: 'POST',
  });

  const data = await response.json();

  const iosAppName = data?.results[0]?.trackName;

  return { iosAppName };
});

export const SEARCH_IOS_APP_NAME: ActionNamespaceConstants<typeof SEARCH_IOS_APP_NAME_NAMESPACE> =
  SearchIosAppName.constants;
export const searchIosAppName = SearchIosAppName.request;

const SEARCH_ANDROID_APP_NAME_NAMESPACE = 'SEARCH_ANDROID_APP_NAME' as const;
const SearchAndroidAppName = new ReduxAsyncAction(SEARCH_ANDROID_APP_NAME_NAMESPACE);
SearchAndroidAppName.registerRequest(async (packageSlug: string) => {
  const data = await server('google play load', { value: packageSlug });

  const androidAppName = data.text;

  return { androidAppName };
});

export const SEARCH_ANDROID_APP_NAME: ActionNamespaceConstants<typeof SEARCH_ANDROID_APP_NAME_NAMESPACE> =
  SearchAndroidAppName.constants;
export const searchAndroidAppName = SearchAndroidAppName.request;

const UPDATE_IS_EDITING_NAMESPACE = 'UPDATE_IS_EDITING' as const;
const UpdateIsEditing = new ReduxAsyncAction(UPDATE_IS_EDITING_NAMESPACE);
UpdateIsEditing.registerRequest(async (isEditing: boolean) => {
  return { isEditing };
});

export const UPDATE_IS_EDITING: ActionNamespaceConstants<typeof UPDATE_IS_EDITING_NAMESPACE> = UpdateIsEditing.constants;
export const updateIsEditing = UpdateIsEditing.request;

const UPDATE_SELECTED_AD_LINK_NAMESPACE = 'UPDATE_SELECTED_AD_LINK' as const;
const UpdateSelectedAdLink = new ReduxAsyncAction(UPDATE_SELECTED_AD_LINK_NAMESPACE);
UpdateSelectedAdLink.registerRequest(async (selectedAdLink: Record<string, any>) => {
  return { selectedAdLink };
});

export const UPDATE_SELECTED_AD_LINK: ActionNamespaceConstants<typeof UPDATE_SELECTED_AD_LINK_NAMESPACE> =
  UpdateSelectedAdLink.constants;
export const updateSelectedAdLink = UpdateSelectedAdLink.request;

const FETCH_AD_LINK_NAMESPACE = 'FETCH_AD_LINK' as const;
const FetchAdLink = new ReduxAsyncAction(FETCH_AD_LINK_NAMESPACE);
FetchAdLink.registerRequest(async (adLinkId: string) => {
  try {
    const { data } = await dash_api.get(`/v1/linkhub/ad/${adLinkId}`);

    return AdLinkEditorService.getAdLinkPayload(data);
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch ad link.', 'error');
    throw error;
  }
});

export const FETCH_AD_LINK: ActionNamespaceConstants<typeof FETCH_AD_LINK_NAMESPACE> = FetchAdLink.constants;
export const fetchAdLink = FetchAdLink.request;

const UPDATE_EDITED_AD_LINK_NAMESPACE = 'UPDATE_EDITED_AD_LINK' as const;
const UpdateEditedAdLink = new ReduxAsyncAction(UPDATE_EDITED_AD_LINK_NAMESPACE);
UpdateEditedAdLink.registerRequest(
  async (adLinkId: string, adLink: AdLinkCreatorReducerType, domain: string, selectedTemplate?: ILinkTemplateRecord) => {
    try {
      const payload = AdLinkCreatorService.getAdLinkPayload({ ...adLink, domain });

      const templateId = selectedTemplate?.id;
      const templatePath = templateId ? `/template/${templateId}` : '';

      const response = await dash_api.put(`/v1/linkhub/ad/${adLinkId}${templatePath}`, payload);

      return { editedAdLink: response.data };
    } catch (error) {
      NotificationActions.showNotification('Failed to edit ad link.', 'error');

      throw error;
    }
  }
);

export const UPDATE_EDITED_AD_LINK: ActionNamespaceConstants<typeof UPDATE_EDITED_AD_LINK_NAMESPACE> =
  UpdateEditedAdLink.constants;
export const updateEditedAdLink = UpdateEditedAdLink.request;

const CREATE_AD_LINK_NAMESPACE = 'CREATE_AD_LINK' as const;
const CreateAdLink = new ReduxAsyncAction(CREATE_AD_LINK_NAMESPACE);
CreateAdLink.registerRequest(
  async (adLink: AdLinkCreatorReducerType, domain: string, selectedTemplate?: ILinkTemplateRecord) => {
    try {
      const payload = AdLinkCreatorService.getAdLinkPayload({ ...adLink, domain });

      const templateId = selectedTemplate?.id;
      const templatePath = templateId ? `/template/${templateId}` : '';

      const response = await dash_api.post(`/v1/linkhub/ad${templatePath}`, payload);

      return { createdAdLink: response.data };
    } catch (error) {
      NotificationActions.showNotification('Failed to create ad link.', 'error');

      throw error;
    }
  }
);

export const CREATE_AD_LINK: ActionNamespaceConstants<typeof CREATE_AD_LINK_NAMESPACE> = CreateAdLink.constants;
export const createAdLink = CreateAdLink.request;

const FETCH_AD_LINK_TEMPLATE_NAMESPACE = 'FETCH_AD_LINK_TEMPLATE' as const;
const FetchAdLinkTemplate = new ReduxAsyncAction(FETCH_AD_LINK_TEMPLATE_NAMESPACE);
FetchAdLinkTemplate.registerRequest(async (templateId: string) => {
  try {
    const { data: selectedTemplate } = await dash_api.get(`/v1/linkhub/ad-link-templates/${templateId}`);
    return { selectedTemplate };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch template.', 'error');

    throw error;
  }
});

export const FETCH_AD_LINK_TEMPLATE: ActionNamespaceConstants<typeof FETCH_AD_LINK_TEMPLATE_NAMESPACE> =
  FetchAdLinkTemplate.constants;
export const fetchAdLinkTemplate = FetchAdLinkTemplate.request;

const AD_LINK_UPDATE_SELECTED_TEMPLATE_NAMESPACE = 'AD_LINK_UPDATE_SELECTED_TEMPLATE' as const;
const AdLinkUpdateSelectedTemplate = new ReduxAsyncAction(AD_LINK_UPDATE_SELECTED_TEMPLATE_NAMESPACE);
AdLinkUpdateSelectedTemplate.registerRequest(async (selectedTemplate: IAdLinkTemplate) => {
  return { selectedTemplate };
});

export const AD_LINK_UPDATE_SELECTED_TEMPLATE: ActionNamespaceConstants<typeof AD_LINK_UPDATE_SELECTED_TEMPLATE_NAMESPACE> =
  AdLinkUpdateSelectedTemplate.constants;
export const adLinkUpdateSelectedTemplate = AdLinkUpdateSelectedTemplate.request;

const BULK_CREATE_AD_LINKS_NAMESPACE = 'BULK_CREATE_AD_LINKS' as const;
const BulkCreateAdLinks = new ReduxAsyncAction(BULK_CREATE_AD_LINKS_NAMESPACE);
BulkCreateAdLinks.registerRequest(async (templateId: string, links: IAdLink[], collectionName?: string) => {
  try {
    const payload = collectionName ? { templateId, links, collectionName } : { templateId, links };

    const response = await dash_api.post('/v1/linkhub/ad/bulk', payload);

    return response;
  } catch (error) {
    NotificationActions.showNotification('Failed to bulk create ad links.', 'error');

    throw error;
  }
});

export const BULK_CREATE_AD_LINKS: ActionNamespaceConstants<typeof BULK_CREATE_AD_LINKS_NAMESPACE> =
  BulkCreateAdLinks.constants;
export const bulkCreateAdLinks = BulkCreateAdLinks.request;

const DELETE_AD_LINK_NAMESPACE = 'DELETE_AD_LINK' as const;
const DeleteAdLink = new ReduxAsyncAction(DELETE_AD_LINK_NAMESPACE);
DeleteAdLink.registerRequest(async (adLinkId: string) => {
  try {
    const { data } = await dash_api.delete(`/v1/linkhub/ad/${adLinkId}`);

    NotificationActions.showNotification(`Link '${data.data.$link_title}' deleted`, 'success');

    return AdLinkEditorService.getAdLinkPayload(data);
  } catch (error) {
    NotificationActions.showNotification('Failed to delete ad link.', 'error');
    throw error;
  }
});

export const DELETE_AD_LINK: ActionNamespaceConstants<typeof DELETE_AD_LINK_NAMESPACE> = DeleteAdLink.constants;
export const deleteAdLink = DeleteAdLink.request;

const ARCHIVE_AD_LINK_NAMESPACE = 'ARCHIVE_AD_LINK' as const;
const ArchiveAdLink = new ReduxAsyncAction(DELETE_AD_LINK_NAMESPACE);
ArchiveAdLink.registerRequest(async (adLinkId: string, archived: boolean) => {
  try {
    const { data } = await dash_api.get(`/v1/linkhub/ad/${adLinkId}`);

    const payload = AdLinkEditorService.getAdLinkPayload(data);

    const response = await dash_api.put(`/v1/linkhub/ad/${adLinkId}/${archived}`, payload);

    return response;
  } catch (error) {
    NotificationActions.showNotification('Failed to archive ad link.', 'error');

    throw error;
  }
});

export const ARCHIVE_AD_LINK: ActionNamespaceConstants<typeof ARCHIVE_AD_LINK_NAMESPACE> = ArchiveAdLink.constants;
export const archiveAdLink = ArchiveAdLink.request;

const UPDATE_BULK_AD_COLLECTION_NAME_NAMESPACE = 'UPDATE_BULK_AD_COLLECTION_NAME' as const;
const UpdateBulkAdCollectionName = new ReduxAsyncAction(UPDATE_BULK_AD_COLLECTION_NAME_NAMESPACE);
UpdateBulkAdCollectionName.registerRequest(async (bulkCollectionName: string) => {
  return {
    bulkCollectionName,
  };
});

export const UPDATE_BULK_AD_COLLECTION_NAME: ActionNamespaceConstants<typeof UPDATE_BULK_AD_COLLECTION_NAME_NAMESPACE> =
  UpdateBulkAdCollectionName.constants;
export const updateBulkAdCollectionName = UpdateBulkAdCollectionName.request;

const FETCH_AD_LINK_COLLECTIONS_NAMESPACE = 'FETCH_AD_LINK_COLLECTIONS' as const;
const FetchAdLinkCollections = new ReduxAsyncAction(FETCH_AD_LINK_COLLECTIONS_NAMESPACE);
FetchAdLinkCollections.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/linkhub/collections?type=ad');

    return { adLinkCollections: response?.data };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch ad link collections.', 'error');

    throw error;
  }
});

export const FETCH_AD_LINK_COLLECTIONS: ActionNamespaceConstants<typeof FETCH_AD_LINK_COLLECTIONS_NAMESPACE> =
  FetchAdLinkCollections.constants;
export const fetchAdLinkCollections = FetchAdLinkCollections.request;
